class IframeOverlay extends HTMLElement {
    constructor() {
        super()
        this.iframeButton = null
        this.iframeOverlay = null
        this.closeButton = null
        this.iframe = null
    }

    connectedCallback() {
        this.iframeButton = this.querySelector("#iframe-button")
        this.iframeOverlay = this.querySelector("#iframe-overlay")
        this.closeButton = this.querySelector("#close-button")
        this.iframe = this.querySelector("iframe")

        if (
            this.iframeButton &&
            this.iframeOverlay &&
            this.closeButton &&
            this.iframe
        ) {
            this.iframeButton.addEventListener("click", () =>
                this.showOverlay()
            )
            this.closeButton.addEventListener("click", () => this.hideOverlay())

            // Add click event to overlay to close when clicking outside the iframe
            this.iframeOverlay.addEventListener("click", (event) => {
                // Check if the click was directly on the overlay (not on iframe or close button)
                if (event.target === this.iframeOverlay) {
                    this.hideOverlay()
                }
            })

            // Remove width and height attributes from iframe
            this.iframe.removeAttribute("width")
            this.iframe.removeAttribute("height")

            // Apply CSS styles
            this.iframe.style.position = "absolute"
            this.iframe.style.top = "0"
            this.iframe.style.left = "0"
            this.iframe.style.width = "100%"
            this.iframe.style.height = "100%"
            this.iframe.style.border = "0"
        }
    }

    showOverlay() {
        this.iframeOverlay.classList.add("active")
        document.body.style.overflow = "hidden"

        // Autoplay YouTube video
        if (this.iframe.src.includes("youtube.com")) {
            // Add autoplay parameter if not already present
            if (this.iframe.src.includes("?")) {
                this.iframe.src += "&autoplay=1"
            } else {
                this.iframe.src += "?autoplay=1"
            }
        }
    }

    hideOverlay() {
        this.iframeOverlay.classList.remove("active")
        document.body.style.overflow = ""

        // Reset video if it's a YouTube iframe
        if (this.iframe.src.includes("youtube.com")) {
            // Remove autoplay parameters
            this.iframe.src = this.iframe.src
                .replace("?autoplay=1", "")
                .replace("&autoplay=1", "")
        }
    }
}

customElements.define("iframe-banner", IframeOverlay)
